import { DateField, type DateFieldProps } from "components/Forms/DateField";
import { Control, FieldValues, Path } from "react-hook-form";

export const CUPA_ANNIVERSARY_DATE_TOOLTIP =
  "The anniversary of this facility's first CUPA submission. Required when the assigned CUPA uses anniversary-based due dates.";

type CupaAnniversaryDateFieldProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
} & Omit<DateFieldProps<T>, "name" | "control" | "label" | "tooltip" | "datePickerProps">;

export function CupaAnniversaryDateField<T extends FieldValues>({
  name,
  control,
  ...props
}: CupaAnniversaryDateFieldProps<T>) {
  return (
    <DateField
      name={name}
      label="CUPA Anniversary Date"
      control={control}
      tooltip={CUPA_ANNIVERSARY_DATE_TOOLTIP}
      datePickerProps={{ views: ["month", "day"] }}
      {...props}
    />
  );
}
